<h4 id="upper" class=" my-4">Importation  & Edition PDC</h4>

<div class="container d-flex justify-content-center">
  <div class="card col-md-10 shadow">
    <div class="card-body text-center">
      <h5 class="card-title">Importez un fichier Excel de PDC</h5>

      <!-- Champs Année de début et Date d'adoption -->
      <div class="row mb-3">
        <div class="col-md-6">
          <label for="anneeDebut">Année de début :</label>
          <input type="number" id="anneeDebut" class="form-control" [(ngModel)]="anneeDebut" min="2000">
        </div>
        <div class="col-md-6">
          <label for="dateAdoption">Date d'adoption :</label>
          <input type="date" id="dateAdoption" class="form-control" [(ngModel)]="dateAdoption">
        </div>
      </div>

      <!-- Zone Drag & Drop -->
      <div class="upload-container" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)">

        <input type="file" #fileInput accept=".xls,.xlsx" (change)="onFileSelected($event)" hidden>

        <div class="upload-box" (click)="triggerFileInput()">
          <i class="pi pi-cloud-upload text-primary" style="font-size: 2rem"></i>
          <p>Glissez-déposez un fichier ici ou cliquez pour importez un fichier Excel</p>
        </div>
      </div>

      <!-- Fichier sélectionné -->
      <p *ngIf="fileName" class="mt-2 text-success">
        <strong>Fichier sélectionné :</strong> {{ fileName }}
      </p>

      <!-- Bouton Envoyer -->
      <button class="btn btn-primary mt-3" (click)="uploadFile()"  [disabled]="isSubmitted ===false">Envoyer</button>
    </div>
  </div>
</div>

<!-- Cartes Résumé -->
<div class="container my-4" *ngIf="showcard">
  <div class="row text-center">
    <div class="col-md-4">
      <div class="card shadow">
        <div class="card-body">
          <h5 class="card-title">Programmes</h5>
          <p class="card-text">{{ totalProgrammes || 0 }}</p>
          <!-- Bouton Voir Plus -->
          <div class="text-center mt-3">
            <button class="btn btn-secondary" (click)="voirPlusPdcFinancementAction('')">Voir Plus</button>
          </div>
        </div>


      </div>
    </div>
    <div class="col-md-4">
      <div class="card shadow">
        <div class="card-body">
          <h5 class="card-title">Actions</h5>
          <p class="card-text">{{ totalActions || 0  }}</p>
          <div class="text-center mt-3">
            <button class="btn btn-secondary" (click)="voirPlusAction('')">Voir Plus</button>
          </div>
        </div>

        <!-- Bouton Voir Plus -->

      </div>
    </div>
    <div class="col-md-4">
      <div class="card shadow">
        <div class="card-body">
          <h5 class="card-title">Activités</h5>
          <p class="card-text">{{ totalActivites || 0 }}</p>

          <!-- Bouton Voir Plus -->
          <div class="text-center mt-3">
            <button (click)="voirPlusPdcFinancementActivite('')" class="btn btn-secondary">Voir Plus</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-toast position="center" />
<ngx-ui-loader></ngx-ui-loader>